<template>
  <b-alert
    :show="countdown"
    :variant="variant"
    :dismissible="closable"
    fade
    @dismissed="close"
    @dismiss-count-down="handleCountdown"
  >
    {{ message }}
  </b-alert>
</template>

<script>
export default {
  name: 'alert-component',

  props: {
    message: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'success',
      validator(value) {
        return ['error', 'warning', 'success'].includes(value);
      },
    },
    duration: {
      type: [Number, null],
      default: null,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      countdown: false,
    };
  },

  mounted() {
    if (!this.duration || this.duration <= 0) {
      this.countdown = true;
      return;
    }

    this.countdown = Math.ceil(this.duration / 1000);
  },

  methods: {
    handleCountdown(value) {
      this.countdown = value;
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .alert {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .alert {
    font-size: 0.85rem;
  }
}
</style>
